export class Option {
    public readonly id: string;
    public readonly amount: number;
    public readonly rateOfInterest: number;
    public readonly effectiveRateOfInterest: number;
    public readonly tenure: number;
    public readonly emi: number;
    public readonly subventedAmount: number;

    constructor(loanAmount?: number, interestRate?: number, tenureInMonths?: number, emiAmount?: number, subventedAmount?: number, effectiveRateOfInterest?: number)
    constructor(loanAmount: number, interestRate: number, tenureInMonths: number, emiAmount: number, subventedAmount?: number, effectiveRateOfInterest?: number) {
        this.amount = loanAmount;
        this.rateOfInterest = interestRate;
        this.tenure = tenureInMonths;
        this.emi = emiAmount;
        this.subventedAmount = subventedAmount;
        this.effectiveRateOfInterest = effectiveRateOfInterest;
    }
}
